/**
 * Centralized video detection utility
 * Add new video extensions here to support them across the entire application
 */
// Supported video file extensions
const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.mkv', '.wmv', '.flv'];
// Video MIME type prefixes
const VIDEO_MIME_PREFIXES = ['video/'];
// Special URL patterns that indicate video content
const VIDEO_URL_PATTERNS = ['video/'];
/**
 * Checks if a file type indicates it's a video
 * @param fileType - MIME type of the file (e.g., 'video/mp4', 'image/jpeg')
 * @returns true if the file is a video
 */
export const isVideoByFileType = (fileType) => {
    return VIDEO_MIME_PREFIXES.some((prefix) => fileType.startsWith(prefix));
};
/**
 * Checks if a URL indicates it's a video based on file extension or URL patterns
 * @param url - The URL to check
 * @returns true if the URL appears to be a video
 */
export const isVideoByUrl = (url) => {
    if (!url)
        return false;
    // Check for video file extensions
    const hasVideoExtension = VIDEO_EXTENSIONS.some((ext) => url.includes(ext));
    // Check for video URL patterns
    const hasVideoPattern = VIDEO_URL_PATTERNS.some((pattern) => url.includes(pattern));
    // Special case: BackgroundImage URLs with video extensions
    const isBackgroundImageVideo = url.includes('BackgroundImage/') && hasVideoExtension;
    return hasVideoExtension || hasVideoPattern || isBackgroundImageVideo;
};
/**
 * Comprehensive video detection that works with both file types and URLs
 * @param fileType - MIME type of the file (optional)
 * @param url - URL of the file (optional)
 * @returns true if either the file type or URL indicates it's a video
 */
export const isVideo = (fileType, url) => {
    if (fileType && isVideoByFileType(fileType))
        return true;
    if (url && isVideoByUrl(url))
        return true;
    return false;
};
